import { all, fork } from "redux-saga/effects";
import forgetPasswordSaga from "./auth/forgetpwd/saga";
import authSaga from "./auth/login/saga";
import ProfileSaga from "./auth/profile/saga";
import accountSaga from "./auth/register/saga";
import customerSaga from "./customer/saga";
import dashboardSaga from "./dashboard/saga";
import groupTransportSaga from "./group-transport/saga";
import LayoutSaga from "./layout/saga";
import menuSaga from "./menu/saga";
import notificationManagementSaga from "./notification-management/saga";
import reportManagementSaga from "./report-management/saga";
import routeSaga from "./route/saga";
import shippingUnitSaga from "./shipping-unit/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(accountSaga),
    fork(authSaga),
    fork(forgetPasswordSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(dashboardSaga),
    fork(menuSaga),
    fork(notificationManagementSaga),
    fork(shippingUnitSaga),
    fork(customerSaga),
    fork(routeSaga),
    fork(reportManagementSaga),
    fork(groupTransportSaga),
  ]);
}
